
(function () {
    'use strict';

    angular.module("handbookApp")
        .controller(controllers.chapterController, chapterController);

    chapterController.$inject = ['$scope', '$http', '$state', '$stateParams', '$timeout', '$sce', '$rootScope', '$filter',
        'broadcastService', 'favoriteService', 'tabStateService', 'resizeService', 'localStorageService', 'treeNavigationService',
        'documentService', '$location', 'browserService', '$uibModal', '$anchorScroll', 'configService'];

    function chapterController($scope, $http, $state, $stateParams, $timeout, $sce, $rootScope, $filter,
        broadcastService, favoriteService, tabStateService, resizeService, localStorageService, treeNavigationService,
        documentService, $location, browserService, $uibModal, $anchorScroll, configService) {
        var attachmentStores = {};
        var vm = this;
        vm.handbookRequests = handbookRequests;
        vm.isPinMeta = localStorageService.getItem(localStorageKeys.stateOfSticky);
        vm.isPinMeta = configService.getBool(vm.isPinMeta);
        vm.pinMetaChange = pinMetaChange;
        $scope.translation = globalResources;
        $scope.internetPublishOption = configService.getBool(HandbookConfiguration.InternetPublishOption);
        vm.publishedVersion = configService.getBool(HandbookConfiguration.PublishedVersion);
        vm.commonGridSettingKey = gridSettingKeys.commonVisibilitySettings;
        vm.folderId = $stateParams.folderId;       

        vm.groupDocuments = [];
        vm.folderList = {};
        vm.folderInformation = {};
        vm.keyword = $location.$$search.keyword || '';
        vm.groupDocumentAnchorPrefix = prefix.groupDocumentAnchorPrefix;
        vm.addFavoriteRequest = handbookRequests.AddFavoriteFolder;
        vm.removeFavoriteRequest = handbookRequests.RemoveFavoriteFolder;
        vm.addEmailSubscriptionRequest = handbookRequests.AddEmailSubscription;
        vm.removeEmailSubscriptionRequest = handbookRequests.RemoveEmailSubscription;

        vm.urlchapter = window.location.origin + '/folder/' + vm.folderId;

        vm.backendIsDb4 = configService.getBool(HandbookConfiguration.BackendIsDb4);
        vm.showFolderLinkToBackend = false;

        vm.objectShowDocumentsInSubChapters = {
            showDocumentsInSubChapters: $location.$$search.showDocumentsInSubChapters? true : false
        };

        vm.DocumentViewTypes = [
            { Id: documentViewTypes.DocumentViewTypes_Standard, Name: globalResources.Folders.DocumentViewStandard },
            { Id: documentViewTypes.DocumentViewTypes_Template, Name: globalResources.DocumentType }
        ];
        vm.metaDataTags = [];
        vm.documentViewTypes_Standard = documentViewTypes.DocumentViewTypes_Standard;
        vm.documentViewTypes_Template = documentViewTypes.DocumentViewTypes_Template;
        vm.documentViewTypes_Internet = documentViewTypes.DocumentViewTypes_Internet;
        vm.onRowClick = onRowClick;
        vm.changeDocumentView = changeDocumentView;
        vm.gotoParentFolder = gotoParentFolder;
        vm.showDocumentsRecursive = showDocumentsRecursive;
        vm.removeFromFavorite = removeFromFavorite;
        vm.getConsecutiveIndex = getConsecutiveIndex;
        //vm.adjustContentPosition = adjustContentPosition;
        vm.showAllDocuments = showAllDocuments;
        vm.showDocumentsIncludeLevel1 = showDocumentsIncludeLevel1;
        vm.searchInFolder = searchInFolder;
        vm.toTopGroup = toTopGroup;
        vm.backToFolderView = backToFolderView;
        vm.showWhatsNewDocumentsRecursive = showWhatsNewDocumentsRecursive;
        vm.linkToFolderManagement = linkToFolderManagement;
		vm.showAllGroups = showAllGroups;
        vm.changeSelectedOption = changeSelectedOption;
        vm.nameFolderWithMetaTag = nameFolderWithMetaTag;
        vm.urlFolderWithMetaTag = urlFolderWithMetaTag;
        vm.getFolderClassMobile = getFolderClassMobile;
        vm.backToFolderMobileView = backToFolderMobileView;

        vm.currentRowIndex = 0;
        vm.totalDocuments = 0;
        vm.nextPage = nextPage;
        vm.infiniteGroups = [];
        vm.busy = false;
        vm.newTotalDocuments = 0;
        vm.scrolling = false;
        vm.subFoldersGridSetting = [];
        vm.showDocumentIncludeLevel1 = false;
        vm.showWhatsNewDocumentsInSubChapters = false;
        vm.searchDocuments = [];
        vm.WhatsNewDocuments = [];

        vm.copyUserFriendlyUrlTooltip = globalResources.CopyUserFriendlyUrl;
        vm.BROWSER_TYPE = BrowserType;
        vm.browserType = browserService.detectBrowserWindow();
        vm.showDropdownFolderOptions = false;
        vm.showSortOption = false;
        vm.isStandardView = true;
        vm.isGroupByMetaDataView = false;
        vm.openAboutFolder = openAboutFolder;
        vm.addOnlyFolderEmailSubscription = addOnlyFolderEmailSubscription;
        vm.removeOnlyFolderEmailSubscription = removeOnlyFolderEmailSubscription;
        vm.addRecursiveFolderEmailSubscription = addRecursiveFolderEmailSubscription;
        vm.removeRecursiveFolderEmailSubscription = removeRecursiveFolderEmailSubscription;
        vm.simpleSubscription = configService.getBool(HandbookConfiguration.SimpleSubscription);
        vm.openWhatsNewFolder = openWhatsNewFolder;
        vm.changeSelectedOptionInMobileView = changeSelectedOptionInMobileView;
        vm.collapsed = collapsed;
        vm.autoScrollDownExpandBottom = autoScrollDownExpandBottom;
        vm.metadataGroupTypes = [];
        vm.groupByDocument = groupByDocument;
        var infiniteScrollLoadsize = (HandbookConfiguration.InfiniteScrollLoadGroupSize == "0" || HandbookConfiguration.InfiniteScrollLoadGroupSize == 0) ?
            0 :
            parseInt(HandbookConfiguration.InfiniteScrollLoadGroupSize);

        var infiniteScrollLoadDocumentssize = (HandbookConfiguration.InfiniteScrollLoadSize == "0" || HandbookConfiguration.InfiniteScrollLoadSize == 0) ?
            0 :
            parseInt(HandbookConfiguration.InfiniteScrollLoadSize);
        vm.alerts = [];
        vm.disableFolderView = false;
        $scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
            tabStateService.adjustFolderContentIdentifierHeight();
        });

        $scope.$on(broadcastType.scrollTarget, function (e, target) {
            vm.scrolling = true;
        });

        $scope.$on('ActiveFolderWhatsnew', function (e, target) {
            vm.isWhatsNew = true;
        });

        $scope.$on("$destroy", function () {
            documentService.clearDocumentsInWorker();
            documentService.clearMetaDocumentsInWorker();
        });

        $scope.$on(broadcastType.gridSettingTarget, function (e, target, gridSettingKey) {
            if (gridSettingKey == gridSettingKeys.commonVisibilitySettings) {
                vm.exportParams.columns = getDocumentColumnsForExporting(gridSettingKeys.commonVisibilitySettings, E.GridViewModelType.Document);
            }
        });

        $scope.selectNodeHead = selectNodeHead;
        $scope.selectNodeLabel = selectNodeLabel;

        $(document)
            .on(collapseExpandEvent.shown, function (event) {
                var $target = $(event.target.parentNode);
                $target.find("." + collapseExpandClass.collapse)
                    .removeClass(collapseExpandClass.collapse)
                    .addClass(collapseExpandClass.expand);
            })
            .on(collapseExpandEvent.hidden, function (event) {
                var $target = $(event.target.parentNode);
                $target.find("." + collapseExpandClass.expand)
                    .removeClass(collapseExpandClass.expand)
                    .addClass(collapseExpandClass.collapse);
            })
            .bind('click', function (event) {
                let isClickedElementChildOfPopup = angular.element("#moreIcon").find(event.target).length > 0 ||
                    angular.element("#moreIconChild").find(event.target).length > 0;
                if (isClickedElementChildOfPopup) {
                    vm.showSortOption = false;
                    return;
                }
                vm.showDropdownFolderOptions = false;

                isClickedElementChildOfPopup = angular.element("#sortIcon").find(event.target).length > 0 ||
                    angular.element("#sortIconChild").find(event.target).length > 0;
                    
                if (isClickedElementChildOfPopup) {
                    return;
                }
                vm.showSortOption = false;
            });
        vm.exportParams = {
            folderId: vm.folderId,
            isRecursive: false,
            groupBy: E.exportDocumentGroupsByColumn.none
        };

        initialize();

        function initialize() {
			var storageWhatsNewPeriodFolder = localStorageService.getItem("WhatsNewPeriodFolder");
			vm.selectedOption = storageWhatsNewPeriodFolder != null ? storageWhatsNewPeriodFolder : parseInt(HandbookConfiguration.WhatsNewPeriodFolder);

            resizeService.resizeView();

            getGridSetting(gridSettingKeys.commonVisibilitySettings);
            getColumnsDefinition(gridSettingKeys.commonVisibilitySettings);
            buildSubFoldersGridSetting();
            vm.exportParams.columns = getDocumentColumnsForExporting(gridSettingKeys.commonVisibilitySettings, E.GridViewModelType.Document);
            vm.commonGridColumnDefinition = commonColumnsDefinition;
            vm.optionalColumns = optionalColumnsDenifinition;
            vm.commonColumnsDefinition = angular.copy(optionalColumnsDenifinition);
            vm.hasViewAccess = true;
            vm.hasViewContentAccess = true;
            getFolderInfoStorage();

            if (vm.keyword) {
                searchInFolder();
            } else {
                showDocumentsRecursive();
            }

            updateFolderInfoStorage();
            vm.listOutSubChapters = HandbookConfiguration.ListOutSubChapters;

            getWhatsNewForFolder();

            if (!vm.publishedVersion && $scope.internetPublishOption) {
                vm.DocumentViewTypes.push({ Id: documentViewTypes.DocumentViewTypes_Internet, Name: globalResources.publishedOrUnpublished });
            }
            treeNavigationService.navigateToItemLocation(true);
        };

        $(window).on('resize', function () {
            vm.browserType = browserService.detectBrowserWindow();
        });

        function changeSelectedOption() {
			localStorageService.setItem("WhatsNewPeriodFolder", vm.selectedOption);
			getWhatsNewForFolder();
        }

        function changeSelectedOptionInMobileView(period) {
            vm.selectedOption = period.value;
            localStorageService.setItem("WhatsNewPeriodFolder", vm.selectedOption);
        }

        //watch the height of the content change
        $scope.$watch(
            function () {
                return angular.element('#' + folderContent.content + '').height();
            },
            function (newValue, oldValue) {
                if (newValue != oldValue) {
                    updateScroll();
                }
            }
        );

        function updateScroll() {
            if (vm.isPinMeta) {            
                var currentHeight = angular.element('#content-body-chapter').height()
                    - angular.element('#chapterItemTabs').height()
                    - angular.element('#topmenuleftid').height()
                    - angular.element('#list-document-type').height()
                    - angular.element('.' + folderContent.groupMetatagList + '').height() - 37;
                          
                angular.element('#' + folderContent.groupMetatagView + '').css({ height: currentHeight, 'overflow-y': 'auto' });                     
            }
            else {
                angular.element('#' + folderContent.groupMetatagView + '').css({ height: '', 'overflow-y': '' });
            }
            localStorageService.setItem(localStorageKeys.stateOfSticky, vm.isPinMeta);
        }
        function pinMetaChange() {
            vm.isPinMeta = !vm.isPinMeta;
            if (vm.infiniteGroups.length != vm.groupDocuments.length) {
                vm.infiniteGroups = vm.groupDocuments;
                vm.newTotalDocuments = vm.infiniteGroups.length;
            }
            updateScroll();
        }

        function linkToFolderManagement() {
            var backendUrl = HandbookConfiguration.BackendURL;
            var lastChar = backendUrl.charAt(backendUrl.length - 1);
            var commonAdd = lastChar == '/' ? '' : '/';
            if (vm.backendIsDb4) {
                var url = backendUrl + '&folder=' + vm.folderId;
                url = url.replace('gk=2', 'gk=1');
                window.open(url, '_blank');
            } else {
                window.open(backendUrl + commonAdd + 'folder/' + vm.folderId, '_blank');
            }
        }

        $scope.$on('linkToFolderManagement', function (e, target) {
            linkToFolderManagement();
        });

        function onRowClick(id) {
            favoriteService.setFavoriteNodeState({ isFavorited: false });
            $state.go(handbookActions.FolderAction, { folderId: id });
        };

        function changeDocumentView() {
            vm.showGroupDocumentTitle = vm.folderInformation.viewType != documentViewTypes.DocumentViewTypes_Standard;
            listedOutDocuments(vm.folderInformation.viewType);
            updateFolderInfoStorage();
            updateExportGroupByParam();
        };

        function selectNodeHead(node) {
            if (node.children == undefined || !node.children.length) {
                $http.get(handbookRequests.GetSubfoldersRequest, { params: { 'folderId': node.id } })
                    .success(function (data, status, headers, config) {
                        node.children = data;
                    });
            }
        };

        function selectNodeLabel(node) {
            $state.go(handbookActions.FolderAction, {
                folderId: node.id
            });
        };

        function gotoParentFolder() {
            $state.go(handbookActions.FolderAction, { folderId: vm.folderInformation.parentFolderId });
        };

        function getWhatsNewForFolder() {
			$http.get(handbookRequests.GetRecentlyApprovedDocumentsForFolder, { params: { 'folderId': vm.folderId, 'includeSubFolder': vm.showWhatsNewDocumentsInSubChapters, 'periodOption': vm.selectedOption } })
                .success(function (data, status, headers, config) {
                    vm.WhatsNewDocuments = data;
                    updateAttachmentsForWhatsNewDocuments(data);
                    documentService.getAgreeFilesForDocuments(vm.WhatsNewDocuments);
                });
        };

        function updateAttachmentsForWhatsNewDocuments(documents) {
            var documentIds = [];
            for (var i = 0; i < documents.length; i++) {
                if (documents[i].hasAttachment) {
                    documentIds.push(documents[i].id);
                }
            }
            if (documentIds.length > 0) {
                $http
                    .post('/api/Documents/GetAttachmentsForDocuments', { documentIds: documentIds })
					.success(function (data) {
						if (data && data.length > 0) {
							data.forEach(function (x) {
								x.itemId = x.extraId ? x.extraId : x.itemId;
							});
						}
                        for (var i = 0; i < documents.length; i++) {
                            if (documents[i].hasAttachment) {
                                documents[i].attachments = [];
                                for (var j = 0; j < data.length; j++) {
                                    if (data[j].documentId == documents[i].id) {
                                        documents[i].attachments.push(data[j]);
                                    }
                                }
                            }
                        }

                    });
            }
        }

        function showWhatsNewDocumentsRecursive() {
            getWhatsNewForFolder();
        }

        function showDocumentsRecursive() {
            listedOutDocuments(vm.folderInformation.viewType);
            updateFolderInfoStorage();
            buildExportFileName();
            vm.exportParams.isRecursive = vm.objectShowDocumentsInSubChapters.showDocumentsInSubChapters;
        };

        function showDocumentsIncludeLevel1() {
            listedOutDocuments(vm.folderInformation.viewType);
            updateFolderInfoStorage();
            updateExportGroupByParam();
        }

        function removeFromFavorite() {
            var requestUrl = vm.removeFavoriteRequest + '/' + vm.folderId;
            $http.post(requestUrl)
                .then(function () {
                    var target = {
                        data: {
                            id: vm.folderId,
                            isDocument: false
                        },
                        requestType: requestType.removeRequest
                    };
                    broadcastService(broadcastType.favoriteTarget, target);
                });
        };

        function getConsecutiveIndex(parentIndex, $index, documents) {
            var total = 0;
            for (var i = 0; i < parentIndex; i += 1) {
                total += documents[i].length;
            }
            return (total + $index);
        }

        function listedOutDocuments(viewType) {
            vm.groupDocuments = [];
            vm.isIncludeLevel1 = false;
            if (viewType != null) {
                if (viewType != documentViewTypes.DocumentViewTypes_Standard && viewType != documentViewTypes.DocumentViewTypes_Template
                    && viewType != documentViewTypes.DocumentViewTypes_Internet) {
                    getDocuments($stateParams.folderId);
                    vm.isIncludeLevel1 = true;
                } else {
                    listedOutDocumentsRecursive();
                }
            } else {
                getDocuments($stateParams.folderId);
            }
        };

        function getMetaGroupName(viewType) {
            var result = '';
            if (vm.DocumentViewTypes && vm.DocumentViewTypes.length > 0) {
                for (var i = 0; i < vm.DocumentViewTypes.length; i++) {
                    if (viewType == vm.DocumentViewTypes[i].Id) {
                        result = vm.DocumentViewTypes[i].Name;
                        break;
                    }
                }
            }
            return result;
        }

        function getMetadataGroupsForContentTab(viewType) {
            vm.isIncludeLevel1 = true;
            vm.metaGroupName = getMetaGroupName(viewType);
            vm.folderData.documents = vm.folderData.documents != null ? vm.folderData.documents : [];
            
            return documentService.getMetaDocumentsViaWorker(
                $stateParams.folderId,
                viewType,
                vm.objectShowDocumentsInSubChapters.showDocumentsInSubChapters,
                vm.showDocumentIncludeLevel1,
                vm.folderData.documents
            )
                .then(function (metadata) {
                    if (!metadata) {
                        return;
                    }

                    vm.metaDataTags = metadata.metaTags;
                    documentService.getAgreeFilesForDocuments(metadata.folderDocuments);
                    if (vm.objectShowDocumentsInSubChapters.showDocumentsInSubChapters) {
                        $http.get(handbookRequests.GetDocumentsRecursive, {
                            params: {
                                'folderId': $stateParams.folderId
                            }
                        }).success(function (data, status, headers, config) {
                            updateAttachmentsForDocuments(data, true);
                            vm.folderData = {
                                documents: data,
                                folders: vm.folderData.folders
                            };
                            mappingDocumentTemplates(metadata.documents);
                            getDocumentsGroupByTypes(vm.folderData.documents, true);
                            buildViewMode();
                        });
                    } else {
                        vm.folderData.documents = metadata.folderDocuments;
                        vm.groupDocuments = metadata.groupDocuments;
                        updateInfiniteScrollingData();
                    }
                });
        }

        function listedOutDocumentsRecursive() {
            if (vm.objectShowDocumentsInSubChapters.showDocumentsInSubChapters) {
                if (!vm.folderInformation || !vm.folderInformation.id) {
                    $http.get("/api/Documents/GetFolderInformation", { params: { 'folderId': $stateParams.folderId } })
                        .success(function (data, status, headers, config) {
                            vm.isFavoriteNodeSelected = true;

                            angular.extend(vm.folderInformation, {
                                level: data.level,
                                levelTypeText: data.levelTypeText,
                                parentFolderId: data.parentFolderId,
                                viewType: vm.folderInformation.viewType || data.viewType,
                                name: data.name,
                                isFavorite: data.isFavorite,
                                hasEmailSubscription: data.hasEmailSubscription,
                                hasOnlyFolderEmailSubscription: data.hasOnlyFolderEmailSubscription,
                                isFavoriteReadonly: data.isFavoriteReadonly,
                                documentTemplates: data.documentTemplates,
                                type: data.type,
                                nodeType: convertToNodeType(data.type),
                                id: data.id,
                                description: data.description == null ? '' : $sce.trustAsHtml(data.description),
                                icon: getFolderClassMobile(data.type)
                            });
                            buildExportFileName();
                            vm.showGroupDocumentTitle = vm.folderInformation.viewType != documentViewTypes.DocumentViewTypes_Standard;
                            vm.showFolderLinkToBackend = configService.getBool(HandbookConfiguration.ShowDocumentLinkToBackend) && data.hasWritePermission;
                            vm.folderIcon = getFolderIcon(vm.folderInformation.type);
                        });
                }
                $http.get(handbookRequests.GetDocumentsRecursive, {
                    params: {
                        'folderId': $stateParams.folderId,
                        showLoading: true
                    }
                }).success(function (data, status, headers, config) {
                    updateAttachmentsForDocuments(data, true);
                    vm.folderData = {
                        documents: data,
                        folders: vm.folderData != null ? vm.folderData.folders : null
                    };
                    angular.extend(vm.folderInformation, {
                        documentTemplates: getDocumentTemplates(data)
                    });
                    buildExportFileName();
                    angular.forEach(vm.folderData.documents, function (document) {
                        document.internetDocumentString = document.internetDocument ? globalResources.publishedInternet : globalResources.unpublishedInternet;
                    });

                    documentService.getAgreeFilesForDocuments(vm.folderData.documents);
                    getDocumentsGroupByTypes(vm.folderData.documents);

                    buildViewMode();
                });

                if (HandbookConfiguration.MetadataEnabled == "True") {
                    $http.get(handbookRequests.GetMetadataGroupsRecursive, {
                        params: {
                            'folderId': $stateParams.folderId
                        }
                    }).success(function (data, status, headers, config) {
                        getMetadataGroupTypes(data);
                    });
                }
            } else {
                getDocuments($stateParams.folderId);
            }
        }

        function mappingDocumentTemplates(documentMetatags) {
            if (vm.folderData != null) {
                vm.folderData.documents = vm.folderData.documents != null ? vm.folderData.documents : [];
                vm.folderData.documents.forEach(function (item) {
                    item.templateGroup = globalResources.UndefinedMetatag;
                });
            }
            if (documentMetatags != null && documentMetatags.length > 0 && vm.folderData != null) {
                var length = documentMetatags.length;
                for (var i = 0; i < length; i++) {
                    updateDocumentTemplate(documentMetatags[i], documentMetatags[i].id)
                }
            }
        };

        function updateDocumentTemplate(documentMetatag, id) {
            documentMetatag.templateGroup = documentMetatag.metatagValue;
            var existedDocument = false;
            var length = vm.folderData.documents.length;
            for (var i = 0; i < length; i++) {
                if (vm.folderData.documents[i].id == id
                    && (vm.folderData.documents[i].templateGroup == globalResources.UndefinedMetatag || vm.folderData.documents[i].templateGroup == null)) {
                    vm.folderData.documents[i].templateGroup = documentMetatag.metatagValue || '';
                    existedDocument = true;
                    break;
                }
            }
            if (!existedDocument) {
                vm.folderData.documents.push(angular.copy(documentMetatag));
            }
        };

        function getSortGroupMetadata(metatagValue) {
            var sort = (vm.metaDataTags != null && vm.metaDataTags.length > 0) ? vm.metaDataTags.length + 1 : 0;
            if (vm.metaDataTags != null && vm.metaDataTags.length > 0) {
                for (var i = 0; i < vm.metaDataTags.length; i++) {
                    if (vm.metaDataTags[i].registerValue == metatagValue) {
                        sort = vm.metaDataTags[i].sort;
                        break;
                    }
                }
            }
            return sort;
        }

        function getDocuments(folderId) {
            var previousViewType = (vm.folderInformation != undefined && vm.folderInformation.viewType != undefined) ? vm.folderInformation.viewType : null;
            
            return documentService.getDocumentsViaWorker(folderId, previousViewType).then(function (data) {
                if (data.documentsError || data.hidden || data.errorMessage) {
                    vm.errorMessage = data.errorMessage;
                    vm.disableFolderView = true;
                    runErrorServicesAfterInit();
                    return;
                }

                vm.hasViewContentAccess = data.hasViewContentAccess;
                vm.hasViewAccess = data.hasViewAccess;
                vm.errorMessage = data.errorMessage;

                if (data.errorMessage && !data.documentsError) {
                    var favoriteState = favoriteService.getFavoriteNodeState();
                    vm.isFavoriteNodeSelected = favoriteState.isFavorited;
                    // Update folder information for favorite button can work
                    vm.folderInformation.isFavorite = vm.isFavoriteNodeSelected;
                    vm.folderInformation.id = vm.folderId;
                    runErrorServicesAfterInit();
                    return;
                }

                vm.isFavoriteNodeSelected = true;
            
                vm.folderData = {
                    documents: data.documents && data.documents.length ?  data.documents.filter(x => !x.hidden) : data.documents,
                    folders: data.folders && data.folders.length ? data.folders.filter(x => !x.hidden) : data.folders
                };
                vm.documentsMobile = angular.copy(vm.folderData.documents);
                vm.subFoldersMobile = angular.copy(vm.folderData.folders);
                if (vm.documentsMobile && vm.documentsMobile.length){
                    sortItemsAscByName(vm.documentsMobile);
                }
                if (vm.subFoldersMobile && vm.subFoldersMobile.length){
                    sortItemsAscByName(vm.subFoldersMobile);
                }
                
                documentService.getAgreeFilesForDocuments(vm.folderData.documents);

                vm.showFolderLinkToBackend = configService.getBool(HandbookConfiguration.ShowDocumentLinkToBackend) && data.hasWritePermission;
                if(vm.folderData.folders && vm.folderData.folders.length){
                    angular.forEach(vm.folderData.folders, function (node) {
                        node.icon = getFolderClass(convertToFolderType(node.type))
                    });
                }                

                angular.extend(vm.folderInformation, {
                    level: data.level,
                    levelTypeText: data.levelTypeText,
                    parentFolderId: data.parentFolderId,
                    viewType: data.viewType,
                    name: data.name,
                    isFavorite: data.isFavorite,
                    hasEmailSubscription: data.hasEmailSubscription,
                    hasOnlyFolderEmailSubscription: data.hasOnlyFolderEmailSubscription,
                    isFavoriteReadonly: data.isFavoriteReadonly,
                    documentTemplates: data.documentTemplates,
                    type: data.type,
                    nodeType: convertToNodeType(data.type),
                    id: data.id,
                    description: data.description == null ? '' : $sce.trustAsHtml(data.description),
                    icon: getFolderClassMobile(data.type)
                });
				vm.messageWhatNew = String.format(globalResources.RecentlyApprovedDocumentsInTheHandbook, vm.folderInformation.name);
                buildExportFileName();
                $rootScope.title = globalResources.Handbook + " - " + data.name;

                angular.forEach(data.metadataGroupTypes, function (type) {
                    var exist = vm.DocumentViewTypes.some(function (dt) {
                        return dt.Id == type.Id;
                    })

                    if (!exist) {
                        vm.DocumentViewTypes.push(type);
                    }
                });
                vm.metadataGroupTypes = data.metadataGroupTypes;

                vm.showGroupDocumentTitle = vm.folderInformation.viewType != documentViewTypes.DocumentViewTypes_Standard;
                vm.folderIcon = getFolderIcon(vm.folderInformation.type);

                var isGetMetadataGroupsForContentTab = hasGetMetadataGroupsForContentTab();
                if (isGetMetadataGroupsForContentTab) {
                    getMetadataGroupsForContentTab(vm.folderInformation.viewType);
                }

                if (hasGetDocumentsGroupByTypes()) {
                    vm.groupDocuments = data.groupDocuments;
                    updateInfiniteScrollingData();
                }

                buildViewMode();
                updateExportGroupByParam();

                $timeout(function () {
                    updateScroll();
                }, 500);
            });
        }

        function sortItemsAscByName(items) {
            items.sort(function (a, b) {
                if (a.name.toLowerCase() < b.name.toLowerCase())
                    return -1;
                if (a.name.toLowerCase() > b.name.toLowerCase()) {
                    return 1;
                }
                return 0;
            });
        }

        function hasGetMetadataGroupsForContentTab() {
            return vm.folderInformation.viewType != documentViewTypes.DocumentViewTypes_Standard
                && vm.folderInformation.viewType != documentViewTypes.DocumentViewTypes_Template
                && vm.folderInformation.viewType != documentViewTypes.DocumentViewTypes_Internet;
        }

        function hasGetDocumentsGroupByTypes() {
            return vm.folderInformation.viewType == documentViewTypes.DocumentViewTypes_Standard
                || vm.folderInformation.viewType == documentViewTypes.DocumentViewTypes_Template
                || vm.folderInformation.viewType == documentViewTypes.DocumentViewTypes_Internet;
        }

        function buildViewMode() {
            if ((vm.folderData.documents && vm.folderData.documents.length > 0)
                && (vm.folderData.folders && vm.folderData.folders.length > 0)) {
                vm.viewMode = 2;
            } else if (vm.folderData.folders && vm.folderData.folders.length > 0) {
                vm.viewMode = 1;
            } else {
                vm.viewMode = 0;
            }
        }

        function buildSubFoldersGridSetting() {
            vm.subFoldersGridSetting.push({ id: 'name', name: globalResources.SubFolders.toUpperCase(), width: 100, coldefault: true, icon: 'icon' });
            vm.columnNotRemove = 'name';
        }

        function adjustContentPosition() {
            var tabState = tabStateService.getState(tabStateType.chapterTabState);
            $timeout(function () {
                tabStateService.adjustContentPosition(tabState, tabStateType.chapterTabState);
            }, 0, false);
        };

        function getMetadataGroupTypes(metadataGroups) {
            if (metadataGroups != null && metadataGroups.length > 0) {
                var length = metadataGroups.length;
                for (var i = 0; i < length; i++) {
                    var key = metadataGroups[i].id.toString();
                    if (!existsTemplate(key, vm.DocumentViewTypes)) { // We do not stored duplicated groups
                        vm.DocumentViewTypes.push({ Id: key, Name: metadataGroups[i].name });
                        vm.metadataGroupTypes = metadataGroups;
                    }
                }
            }
        };

        function updateAttachmentsForDocuments(documents, recursive) {

            if (documents) {
                $http
                    .get('/api/Folders/GetAttachmentsInFolder', {
                        params: {
                            folderId: vm.folderId,
                            recursive: recursive ? 1 : 0
                        }
                    })
                    .success(function (data) {
                        for (var i = 0; i < documents.length; i++) {
                            if (documents[i].hasAttachment) {
                                documents[i].attachments = [];
                                for (var j = 0; j < data.length; j++) {
                                    if (data[j].documentId == documents[i].id) {
                                        documents[i].attachments.push(data[j]);
                                    }
                                }
                            }
                        }
                    });
            }
        }

        function existsTemplate(obj, list) {
            for (var i = 0; i < list.length; i++) {
                if (list[i].Id == obj) {
                    return true;
                }
            }

            return false;
        };

        function getDocumentsGroupByTypes(documents, isMetadataGroup) {
            if (documents == null) {
                return;
            }

            var result = groupBy(documents, function (item) {
                if (isMetadataGroup) {
                    return [item.templateGroup];
                } else if (vm.folderInformation.viewType == documentViewTypes.DocumentViewTypes_Internet) {
                    return [item.internetDocumentString];
                } else {
                    return [item.template];
                }
            });

            vm.groupDocuments = [];
            var lastOne = {
                documents: [],
                templateName: '',
                totalDocuments: 0,
                sortGroup: 0
            };
            var hasUndefinedGroup = false;
            for (var i = 0; i < result.length; i++) {
                var sortGroup = 0;
                var documentsGroup = result[i].value.data;

                if (isMetadataGroup && vm.metaDataTags != null && vm.metaDataTags.length > 0) {
                    sortGroup = getSortGroupMetadata(result[i].key);
                    if (vm.objectShowDocumentsInSubChapters.showDocumentsInSubChapters || vm.showDocumentIncludeLevel1) {
                        documentsGroup = $filter('orderBy')(documentsGroup, ['name']);
                    } else {
                        documentsGroup = $filter('orderBy')(documentsGroup, ['order', 'name']);
                    }
                }
                if (result[i].key == globalResources.UndefinedMetatag) {
                    lastOne.documents = documentsGroup;
                    lastOne.templateName = result[i].key;
                    lastOne.totalDocuments = result[i].value.data.length;
                    lastOne.sortGroup = sortGroup;
                    hasUndefinedGroup = true;
                } else {
                    vm.groupDocuments.push({
                        documents: documentsGroup,
                        templateName: result[i].key,
                        totalDocuments: result[i].value.data.length,
                        sortGroup: sortGroup
                    });
                }
            }
            if (isMetadataGroup && vm.metaDataTags != null && vm.metaDataTags.length > 0) {
                if (!checkSortOrderMetaTags(vm.groupDocuments)) {
                    vm.groupDocuments.sort(function (a, b) {
                        return a.sortGroup - b.sortGroup;
                    });
                } else {
                    vm.groupDocuments.sort(function (a, b) {
                        return a.templateName.toLowerCase().localeCompare(b.templateName.toLowerCase());
                    });
                }
            } else {
                vm.groupDocuments.sort(function (a, b) {
                    return a.templateName.toLowerCase().localeCompare(b.templateName.toLowerCase());
                });
            }

            if (hasUndefinedGroup) {
                vm.groupDocuments.push(lastOne);
            }

            updateInfiniteScrollingData();
        }

        function checkSortOrderMetaTags(data) {
            if (data == null || data.length == 0) {
                return true;
            }
            return data[data.length - 1].sortGroup == data[0].sortGroup && data[data.length - 1].sortGroup == 0;
        }

        function updateInfiniteScrollingData() {
            if (!vm.groupDocuments) {
                return;
            }
            var newTotal = vm.groupDocuments != null ? vm.groupDocuments.length : 0;
            if (infiniteScrollLoadsize == 0) {
                vm.infiniteGroups = vm.groupDocuments;
            } else {
                vm.totalDocuments = newTotal;
                vm.currentRowIndex = 0;
                vm.infiniteGroups = getAPage();
                scrollToGroupDocument();
                vm.newTotalDocuments = 0;
                vm.scrolling = false;
                if (vm.browserType != BrowserType.MOBILE) {
                    $timeout(function () { //scroll a bit up
                        var folderContentObject = angular.element('#' + folderContent.content + '')[0];
                        var scrollTop = folderContentObject.scrollTop;
                        folderContentObject.scrollTop -= scrollTop / 2;
                    }, 10, false);
                }
            }
            checkShowAllGroupLink(vm.infiniteGroups);
            initShowGroups();
        }

        function scrollToGroupDocument() {   
            $timeout(function () {
                var anchorGroup = $location.hash();
                var indexToScroll = Number(anchorGroup.split('-').pop() || 0);
                if (vm.infiniteGroups[indexToScroll]) {
                    vm.infiniteGroups[indexToScroll].isShow = true;
                    vm.infiniteGroups[indexToScroll].isToggled = false;
                }
                
                if (anchorGroup) {
                    $location.hash(anchorGroup);
                    $anchorScroll();
                }
            }, 100);
        }

        function checkShowAllGroupLink(infiniteGroups) {
            if (!vm.groupDocuments || !infiniteGroups) {
                return;
            }

            var result = false;
            if (infiniteGroups.length <= vm.groupDocuments.length) {
                result = checkDocumentsInOneGroup();
            } else {
                result = true;
            }
            vm.showAllGroup = result;
        }

        function initShowGroups() {
            var length = vm.infiniteGroups.length > 5 ? 5 : vm.infiniteGroups.length;
            for (var i = 0; i < vm.infiniteGroups.length; i++) {
                if (i < length) {
                    vm.infiniteGroups[i].isShow = true;
                    vm.infiniteGroups[i].isToggled = false;
                } else {
                    vm.infiniteGroups[i].isShow = false;
                    vm.infiniteGroups[i].isToggled = true;
                }
            }
        }

        function checkDocumentsInOneGroup() {
            for (var i = 0; i < vm.groupDocuments.length; i++) {
                var item = vm.groupDocuments[i];
                if (item.totalDocuments > infiniteScrollLoadDocumentssize) {
                    return true;
                }
            }
            return false;
        }

        function getDocumentTemplates(documents) {
            if (documents != null) {
                var result = [];
                var lastOne = '';
                var hasUndefinedGroup = false;
                for (var i = 0; i < documents.length; i++) {
                    if (result.indexOf(documents[i].template) < 0) {
                        if (documents[i].template == globalResources.UndefinedMetatag) {
                            lastOne = documents[i].template;
                            hasUndefinedGroup = true;
                        } else {
                            result.push(documents[i].template);
                        }
                    }
                }

                result.sort(function (a, b) {
                    return a.toLowerCase().localeCompare(b.toLowerCase());
                });

                if (hasUndefinedGroup) {
                    result.push(lastOne);
                }

                var groupTemplates = [], columns = 6;
                for (var j = 0; j < result.length; j += columns) {
                    groupTemplates.push(result.slice(j, j + columns));
                }

                return groupTemplates;
            }

            return [];
        };

        function getFolderClass(folderType) {
            switch (folderType.toString()) {
                case E.folderTypes.Folder:
                    return 'folder-5-icon';
                case E.folderTypes.TopFolder:
                    return 'folder-6-icon';
                case E.folderTypes.DepartmentFolder:
                    return 'folder-7-icon';
                case E.folderTypes.RegionalFolder:
                    return 'folder-8-icon';
                default:
                    return 'folder-5-icon';
            }
        }

        function getFolderClassMobile(folderType) {
            switch (folderType.toString()) {
                case E.folderTypes.Folder:
                    return 'folder-blue-icon';
                case E.folderTypes.TopFolder:
                    return 'folder-orange-icon';
                case E.folderTypes.DepartmentFolder:
                    return 'folder-green-icon';
                case E.folderTypes.RegionalFolder:
                    return 'folder-regional-icon';
                default:
                    return 'folder-blue-icon';
            }
        }

        function getFolderIcon(folderType) {
            switch (folderType.toString()) {
                case E.folderTypes.Folder:
                    return paths.FolderIcon;
                case E.folderTypes.RegionalFolder:
                    return paths.RegionalFolderIcon;
                case E.folderTypes.TopFolder:
                    return paths.TopFolderIcon;
                case E.folderTypes.DepartmentFolder:
                    return paths.DepartmentFolderIcon;
                default:
                    return paths.FolderIcon;
            }
        };

        function convertToNodeType(folderType) {
            switch (folderType.toString()) {
                case E.folderTypes.Folder:
                    return E.nodeTypes.Folder;
                case E.folderTypes.TopFolder:
                    return E.nodeTypes.TopFolder;
                case E.folderTypes.DepartmentFolder:
                    return E.nodeTypes.DepartmentFolder;
                case E.folderTypes.RegionalFolder:
                    return E.nodeTypes.RegionalFolder;
            }
        };

        function convertToFolderType(nodeType) {
            switch (nodeType.toString()) {
                case E.nodeTypes.Folder:
                    return E.folderTypes.Folder;
                case E.nodeTypes.TopFolder:
                    return E.folderTypes.TopFolder;
                case E.nodeTypes.DepartmentFolder:
                    return E.folderTypes.DepartmentFolder;
                case E.nodeTypes.RegionalFolder:
                    return E.folderTypes.RegionalFolder;
            }
        };

        function runErrorServicesAfterInit() {
            tabStateService.closeOpenedTabIfNoPrivilege(tabStateType.chapterTabState);
        };

        function updateFolderInfoStorage() {
            var showDocumentsInSubChapters = vm.objectShowDocumentsInSubChapters ? !!vm.objectShowDocumentsInSubChapters.showDocumentsInSubChapters : false;
            var arrFolderInfo = [];
            var folderExist = false;
            var folderInfo = localStorageService.getItem(folderInformationKeyStorage);
            if (folderInfo != null) {
                var folders = JSON.parse(folderInfo);
                if (folders.constructor === Array) {
                    for (var i = 0; i < folders.length; i++) {
                        var folder = folders[i];
                        if (folder.folderId != vm.folderId) {
                            continue;
                        }
                        folder.folderId = vm.folderId;
                        folder.recursive = showDocumentsInSubChapters;
                        folder.template = vm.folderInformation.viewType;
                        folder.includeLevel1 = vm.showDocumentIncludeLevel1;
                        folderExist = true;
                        break;
                    }
                    arrFolderInfo = folders;
                }
            }
            if (!folderExist) {
                arrFolderInfo.push({
                    folderId: vm.folderId,
                    recursive: showDocumentsInSubChapters,
                    template: vm.folderInformation.viewType,
                    includeLevel1: vm.showDocumentIncludeLevel1
                });
            }

            localStorageService.setItem(folderInformationKeyStorage, JSON.stringify(arrFolderInfo));
        }

        function getFolderInfoStorage() {
            var folderInfo = localStorageService.getItem(folderInformationKeyStorage);
            var viewFolder = $location.search().viewFolder;

            if (folderInfo != null) {
                var folderInfoObject = JSON.parse(folderInfo);

                if (folderInfoObject.constructor === Array) {
                    for (var i = 0; i < folderInfoObject.length; i++) {
                        var folder = folderInfoObject[i];
                        if (folder.folderId != vm.folderId) {
                            continue;
                        }
                        vm.objectShowDocumentsInSubChapters.showDocumentsInSubChapters = folder.recursive;
                        vm.folderInformation.viewType = viewFolder ? viewFolder : folder.template;
                        vm.showGroupDocumentTitle = vm.folderInformation.viewType != documentViewTypes.DocumentViewTypes_Standard;
                        vm.showDocumentIncludeLevel1 = (folder.includeLevel1 != null && folder.includeLevel1 != undefined) ? folder.includeLevel1 : false;
                        updateExportGroupByParam();
                        break;
                    }
                }
            }     

        }

        function getAPage() {
            var data = [];
            var startIndex = vm.currentRowIndex;
            var endIndex = startIndex + infiniteScrollLoadsize;
            for (var i = startIndex; i < endIndex; i++) {
                if (vm.currentRowIndex < vm.totalDocuments) {
                    data.push(vm.groupDocuments[i]);
                    vm.currentRowIndex += 1;
                } else {
                    break;
                }
            }
            return data;
        };

        function nextPage() {
            if (vm.busy) return;

            if (vm.groupDocuments == null || vm.groupDocuments.length == 0) {
                if (vm.folderData != null && vm.folderData.documents != null && hasGetDocumentsGroupByTypes()) {
                    getDocumentsGroupByTypes(vm.folderData.documents);
                }
            }

            vm.busy = true;
            if (infiniteScrollLoadsize == 0) {
                vm.infiniteGroups = vm.groupDocuments;
            } else {
                if (vm.infiniteGroups.length < vm.newTotalDocuments || (vm.scrolling && vm.infiniteGroups.length < vm.groupDocuments.length)) {
                    vm.infiniteGroups = vm.infiniteGroups.concat(getAPage());
                }
            }

            vm.newTotalDocuments = vm.infiniteGroups.length;
            vm.busy = false;
        };

        function showAllGroups(group) {
            if (vm.infiniteGroups.length != vm.groupDocuments.length) {
                vm.infiniteGroups = vm.groupDocuments;
                vm.newTotalDocuments = vm.infiniteGroups.length;
            }
            group.isShow = true;
        }

        function showAllDocuments() {
            vm.infiniteGroups = vm.groupDocuments;
            vm.currentRowIndex = vm.totalDocuments;
            broadcastService('showAllDocumentInGroup', {});
        };

        function searchInFolder() {
            vm.isSearchInFolder = true;
            var searchRequestParams = {
                keyword: vm.keyword,
                searchInContents: true,
                searchType: 3,
                folderId: vm.folderId,
                fromDate: null,
                toDate: null,
                hasExpired: false,
                registerId: null,
                registerItemId: null,
				registerItemValueId: null,
				includeVirtualDocuments: true
            };

            if (!vm.objectShowDocumentsInSubChapters.showDocumentsInSubChapters) {
                searchRequestParams.notRecursiveFolderId = true;
            }


            $location.search('keyword', vm.keyword || undefined);
            $location.search('showDocumentsInSubChapters', vm.objectShowDocumentsInSubChapters.showDocumentsInSubChapters || undefined);

            $http.get(handbookRequests.SearchRequest, { params: searchRequestParams })
                .then(function (response, status, headers, config) {
                    if (response.data.documents != null) {
                        updateAttachmentsForDocuments(response.data.documents.filter(x => !x.hidden));
                        documentService.getAgreeFilesForDocuments(response.data.documents);
                        vm.searchDocuments = response.data.documents.filter(x => !x.hidden);
                        vm.totalHits = vm.searchDocuments.length;
                        vm.totalFound = response.data.documents.filter(x => !x.hidden).length;
                        tabStateService.adjustFolderContentIdentifierHeight();
                    } else {
                        vm.totalHits = 0;
                        vm.totalFound = 0;
                    }
                });
            if (vm.browserType == BrowserType.MOBILE) {
                getDocuments($stateParams.folderId);
            }
        };

        function backToFolderView() {
            vm.isSearchInFolder = false;
            adjustContentPosition();
        }

        function backToFolderMobileView() {
            vm.isSearchInFolder = false;
            vm.keyword = '';
        }

        function toTopGroup() {
            angular.element('#folder-content-identifier').scrollTop(0);
        };

        function buildExportFileName() {
            if (!vm.folderInformation.name) {
                return;
            }
            if (vm.objectShowDocumentsInSubChapters.showDocumentsInSubChapters) {
                vm.exportFileName = String.format(globalResources.Exporter.ChapterWithSubChaptersDocumentList, vm.folderInformation.name);
            } else {
                vm.exportFileName = String.format(globalResources.Exporter.ChapterDocumentList, vm.folderInformation.name);
            }
        }

        function updateExportGroupByParam() {
            if (vm.folderInformation.viewType == documentViewTypes.DocumentViewTypes_Standard) {
                vm.exportParams.groupBy = E.exportDocumentGroupsByColumn.none;
            } else if (vm.folderInformation.viewType == documentViewTypes.DocumentViewTypes_Template) {
                vm.exportParams.groupBy = E.exportDocumentGroupsByColumn.documentType;
            } else {
                vm.exportParams.groupBy = E.exportDocumentGroupsByColumn.metatag;
                vm.exportParams.metadataGroupId = vm.folderInformation.viewType;
                vm.exportParams.includeLevel1 = vm.showDocumentIncludeLevel1;
            }
        }

        function nameFolderWithMetaTag(item) {
            if (item.documents.length) {
                return item.documents[0].folderName + ' - ' + item.templateName;
            }
        }

        function urlFolderWithMetaTag(item, index) {
            if (item.documents.length) {
                var urlName = item.documents[0].handbookId + '?viewFolder=' + vm.folderInformation.viewType + '#groupDocumentHeader-' + index;
                return window.location.origin + '/folder/' + urlName;
            }             

        }

        function openAboutFolder() {
            vm.showDropdownFolderOptions = !vm.showDropdownFolderOptions;
            var modalInstance = $uibModal.open({
                templateUrl: '/app/components/chapter/templates/aboutFolderModal.html',
                controller: 'AboutFolderModalController as vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    model: function () {
                        return {
                            folderData: vm.folderInformation
                        };
                    }
                }
            });
        }

        function addOnlyFolderEmailSubscription() {
            if (!vm.folderInformation.hasEmailSubscription) {
                var requestUrl = handbookRequests.AddOnlyFolderToEmailSubscription + '/' + vm.folderId;
                $http.post(requestUrl)
                    .then(function () {
                        vm.folderInformation.hasOnlyFolderEmailSubscription = !vm.folderInformation.hasOnlyFolderEmailSubscription;
                    });
            }
            vm.showDropdownFolderOptions = !vm.showDropdownFolderOptions;
        }

        function removeOnlyFolderEmailSubscription() {
            var requestUrl = handbookRequests.RemoveOnlyFolderFromEmailSubscription + '/' + vm.folderId;
            $http.post(requestUrl)
                .then(function () {
                    vm.folderInformation.hasOnlyFolderEmailSubscription = !vm.folderInformation.hasOnlyFolderEmailSubscription;
                });
            vm.showDropdownFolderOptions = !vm.showDropdownFolderOptions;
        }

        function addRecursiveFolderEmailSubscription() {
            var requestUrl = handbookRequests.AddEmailSubscription + '/' + vm.folderId;

            $http.post(requestUrl)
                .then(function () {
                    vm.folderInformation.hasEmailSubscription = !vm.folderInformation.hasEmailSubscription;
                    vm.folderInformation.hasOnlyFolderEmailSubscription = false;
                    vm.folderInformation.hasEmailSubscription = true;
                });
            vm.showDropdownFolderOptions = !vm.showDropdownFolderOptions;
        };

        function removeRecursiveFolderEmailSubscription() {
            var requestUrl = handbookRequests.RemoveEmailSubscription + '/' + vm.folderId;

            $http.post(requestUrl)
                .then(function () {
                    vm.folderInformation.hasEmailSubscription = !vm.folderInformation.hasEmailSubscription;
                    vm.folderInformation.hasEmailSubscription = false;
                });
            vm.showDropdownFolderOptions = !vm.showDropdownFolderOptions;
        }

        function openWhatsNewFolder() {
            vm.showDropdownFolderOptions = !vm.showDropdownFolderOptions;
            var modalInstance = $uibModal.open({
                templateUrl: '/app/components/chapter/templates/whatsNewFolderModal.html',
                controller: 'WhatsNewFolderModalController as vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    model: function () {
                        return {
                            hasViewAccess: vm.hasViewAccess,
                            showWhatsNewDocumentsInSubChapters: vm.showWhatsNewDocumentsInSubChapters,
                            selectedOption: vm.selectedOption,
                            hasViewContentAccess: vm.hasViewContentAccess,
                            WhatsNewDocuments: vm.WhatsNewDocuments,
                            changeSelectedOptionInMobileView: vm.changeSelectedOptionInMobileView,
                            folderData: vm.folderInformation,
                        };
                    }
                }
            });
        }


        function collapsed(index) {
            vm.infiniteGroups[index].isToggled = !vm.infiniteGroups[index].isToggled;
            vm.infiniteGroups[index].isShow = !vm.infiniteGroups[index].isToggled
            angular.element('#groupDocument-' + index).toggleClass('collapsed');
            angular.element('#groupDocument-' + index + '_icon').toggleClass('collapsed-arrow').toggleClass('collapse-arrow');
        }

        function autoScrollDownExpandBottom(id) {
            if (vm.infiniteGroups[id].isShow) {
                let groupDocument = $("#groupDocument-" + id);
                let e = document.getElementById('groupDocumentHeader-' + id);
                let positionBottomFolderContentIdentifier = $("#folder-content-identifier").outerHeight() + $("#folder-content-identifier").position().top;

                if ((groupDocument.position().top + groupDocument.outerHeight()) > positionBottomFolderContentIdentifier) {
                    setTimeout(() => {
                        e.scrollIntoView({
                            block: 'start',
                            behavior: 'smooth',
                            inline: 'start'
                        });
                    }, 100);
                }
            }
        }

        function groupByDocument(viewType) {
            if (viewType != documentViewTypes.DocumentViewTypes_Standard && viewType != documentViewTypes.DocumentViewTypes_Template) {
                this.isStandardView = false;
                this.isGroupByMetaDataView = true;
            } else if (viewType == documentViewTypes.DocumentViewTypes_Standard) {
                this.isStandardView = true;
                this.isGroupByMetaDataView = false;
            } 
            else if (viewType == documentViewTypes.DocumentViewTypes_Template || viewType == documentViewTypes.DocumentViewTypes_Internet) {
                this.isStandardView = false;
                this.isGroupByMetaDataView = false;
            }
            vm.folderInformation.viewType = viewType;
            changeDocumentView();
        }
    };
})();